import { createPresence } from '@novachat/client';
import { sendRealtime } from './live';

/** Shared with the mobile app (packages/client/src/presence.ts). */
export const { setDoNotDisturb, reportActivity, reportFocus, resendPresence } = createPresence(sendRealtime);
